import { SparklesIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";

export const DisabledRail = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-gray-50 rounded-lg border border-gray-200 p-3 text-gray-500">
      <div className="flex items-center gap-1.5 mb-1">
        <SparklesIcon className="h-4 w-4 text-gray-400 shrink-0" />
        <span className="text-sm font-medium text-gray-600">
          {t("general.assistantScenarIa.title")}
        </span>
      </div>
      <div className="text-[11px] text-gray-500">
        {t("general.assistantScenarIa.disabledTitle")}
      </div>
      <div className="text-[11px] text-gray-400 mt-1">
        {t("general.assistantScenarIa.disabledReason")}
      </div>
    </div>
  );
};

export default DisabledRail;
